import * as React from 'react';
import styles from './switch.scss';

export interface SwitchProps {
  className: string;
  checked: boolean;
  disabled?: boolean;
  label?: string;
  onChange: (enabled: boolean) => void;
}

export class Switch extends React.Component<SwitchProps, {}> {
  public static defaultProps: Partial<SwitchProps> = {
    className: ''
  };

  private onChange = () => {
    this.props.onChange(!this.props.checked);
  }

  public render(): JSX.Element {
    const { label, checked, disabled } = this.props;
    return (
      <div className={`${this.props.className} ${styles.switchContainer}`}>
        <label className={`${styles.switch}`}>
          {label && <div className={styles.switchLabel}>{label}</div>}
          <input className="visuallyhidden" type="checkbox" checked={checked} onChange={this.onChange} disabled={disabled} />
          <span className={`${styles.slider} slider`} />
        </label>
      </div>
    );
  }
}
